import React, { PureComponent } from 'react'
import { string, bool, func } from 'prop-types'
import FormField from '@active/react-ui/FormField'
import FormGroup from '@active/react-ui/FormGroup'
import FormLabel from '@active/react-ui/FormLabel'
import PasswordInput from '@active/react-ui/PasswordInput'
import { withI18n } from '@active/react-utils/i18n'
import Identity from '@active/react-utils/components/Identity'
import I18nMessage from '../I18nMessage'
import { passwordValidator, confirmPasswordValidator } from '../../../shared/validator'
import './confirmedPassword.scss'

class ConfirmedPassword extends PureComponent {
  static propTypes = {
    name: string.isRequired,
    required: bool,
    passwordLabel: string,
    username: string,
    i18n: func.isRequired,
    usernameSubscribe: string,
  }

  static defaultProps = {
    required: false,
    passwordLabel: '',
    username: '',
    usernameSubscribe: undefined,
  }

  validatePassword = (password, subscribes) => {
    if (!password) return null
    const { username, i18n, usernameSubscribe } = this.props
    const { confirmPassword: { value, error, touched } } = subscribes
    const currentUsername = usernameSubscribe ? (subscribes[usernameSubscribe].value || username) : username
    const errorMsg = passwordValidator(password, currentUsername, i18n)

    if (!errorMsg && value && !error && touched) {
      const errors = i18n(confirmPasswordValidator(value, password, username))
      return errors
    }
    return i18n(errorMsg)
  }

  validateConfirmPassword = (confirmPassword, subscribes) => {
    if (!confirmPassword) return null
    const {
      name, username, i18n, usernameSubscribe,
    } = this.props
    const { value: password } = subscribes[name]
    const currentUsername = usernameSubscribe ? (subscribes[usernameSubscribe].value || username) : username
    const error = i18n(confirmPasswordValidator(confirmPassword, password, currentUsername))
    return error
  }

  render() {
    const {
      name, required, passwordLabel, usernameSubscribe,
    } = this.props
    return (
      <Identity>
        <div className="passport__confirm-password-pwd">
          <FormGroup name={name} required={required} withoutLayout>
            <FormLabel><I18nMessage id={passwordLabel || 'passport.common.label.password'} /></FormLabel>
            <FormField
              requiredError="passport.error.validation.noPassword"
              subscribe={['confirmPassword', usernameSubscribe].filter(i => i)}
              as={PasswordInput}
              autoComplete="new-password"
              aria-describedby="password-rules"
              validate={this.validatePassword}
              renderError={({ error }) => <I18nMessage id={error} />}
              hint={<span id="password-rules"><I18nMessage id="passport.common.notice.passwordRules" /></span>}
            />
          </FormGroup>
        </div>
        <div className="passport__confirm-password-repeat">
          <FormGroup name="confirmPassword" required={required} withoutLayout>
            <FormLabel><I18nMessage id="passport.common.label.confirmpwd" /></FormLabel>
            <FormField
              subscribe={[name, usernameSubscribe].filter(i => i)}
              as={PasswordInput}
              autoComplete="new-password"
              validate={this.validateConfirmPassword}
            />
          </FormGroup>
        </div>
      </Identity>
    )
  }
}

export default withI18n(ConfirmedPassword)
